import "./Agreement.css";

import React, { useState } from "react";
import {
  setAcceptGuilt,
  setAcceptTerms,
} from "../../../store/fine/guiltActions";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";

import { setCurrentStep } from "../../../store/fine/fineActions";

const Agreement = () => {
  const currentStep = useAppSelector((state) => state.fine.currentStep);
  const infringement = useAppSelector((state) => state.fine.infringement);

  const acceptChecked = useAppSelector((state) => state.guilt.acceptTerms);
  const guiltChecked = useAppSelector((state) => state.guilt.acceptGuilt);

  const dispatch = useAppDispatch();

  const onContinueClicked = () => {
    if (acceptChecked && guiltChecked) {
      dispatch(setCurrentStep(currentStep + 1));
    }
  };

  return (
    <div className="agreement-container">
      <div className="first-half">
        <p className="agreement-heading">
          Please complete the following before payment
        </p>
        <div className="agreement-divider" />
        <div className="terms">
          <p className="terms-heading">
            Read and accept the following Terms & Conditions:
          </p>
          <p className="term">
            • The offender is aware that by finalising the transaction the
            offender cited is admitting guilt.
          </p>
          <p className="term">
            • The offender can present himself at court to contest the fine and
            is in no way forced to make payment on the fine.
          </p>
          <p className="term">
            • That it’s the offender's responsibility to ensure that the admin
            mark has been lifted.
          </p>
          <div className="accept-terms-agreement">
            <input
              type="checkbox"
              checked={acceptChecked}
              onChange={(e) => dispatch(setAcceptTerms(e.target.checked))}
            />
            <p>I accept the information stated above</p>
          </div>
          <div className="accept-terms-agreement">
            <input
              type="checkbox"
              checked={guiltChecked}
              onChange={(e) => dispatch(setAcceptGuilt(e.target.checked))}
            />
            <p
              style={{
                flexWrap: "nowrap",
                whiteSpace: "nowrap",
                paddingLeft: 9,
              }}
            >
              I acknowledge that by paying this fine and warrant I am admitting
              guilt
            </p>
          </div>
          <div className="terms-placeholder-container">
            <p className="terms-placeholder">{`[Offender’s Name & Surname - ${infringement?.offenderName}]`}</p>
            <p className="terms-placeholder">
              {`[Date of Signature - ${new Date()
                .toJSON()
                .slice(0, 10)
                .replace(/-/g, "/")}]`}
            </p>
          </div>
        </div>
      </div>
      <div className="second-half">
        <div
          className="continue-button"
          style={{
            background: acceptChecked && guiltChecked ? "#e97700" : "white",
            color: acceptChecked && guiltChecked ? "white" : "#D7D7D7",
            cursor: acceptChecked && guiltChecked ? "pointer" : "default",
          }}
          onClick={() => onContinueClicked()}
        >
          <p>Continue to Payment</p>
        </div>
      </div>
    </div>
  );
};

export default Agreement;
